/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * 태그 정보
 */
export type TripTagInfo = {
  /**
   * 태그 식별자
   */
  tagId: string;
  /**
   * 태그 이름
   */
  tagName: string;
  /**
   * 태그 타입 (BUSINESS: 비즈니스 태그, CUSTOM: 커스텀 태그)
   */
  tagType: TripTagInfo.tagType;
  /**
   * 유저 PUID
   */
  puid: string;
  /**
   * 생성 시간
   */
  createdAt: string;
  /**
   * 수정 시간
   */
  updatedAt: string;
};
export namespace TripTagInfo {
  /**
   * 태그 타입 (BUSINESS: 비즈니스 태그, CUSTOM: 커스텀 태그)
   */
  export enum tagType {
    BUSINESS = 'BUSINESS',
    CUSTOM = 'CUSTOM',
  }
}

